<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: 'RECETAS', link: '/prescription/prescription-list' },
          { label: 'DETALLE DE LA RECETA' }
        ]">
      </app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- LADO IZQUIERDO: RESUMEN -->
      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="profile-header bg-rmd-blue text-center">
            <div class="user-name">RECETA ({{ estatusReceta }})</div>
            <div class="name-center">{{ receta.folio }}</div>
          </div>

          <div class="p-3 text-center">
            <img alt="Paciente" class="user-img" [src]="userImage" />
            <div class="name-center muted mt-2">
              FECHA DE CREACION:
              <strong>{{ receta.fechaCreacion }}</strong>
            </div>

            <div class="rx-actions mt-3" *ngIf="isFolioValido()">
              <button
                mat-raised-button
                color="primary"
                class="rx-action-btn rx-action-btn--primary"
                (click)="$event.stopPropagation(); descargarPDF()">
                <mat-icon>download</mat-icon>
                <span>DESCARGAR RECETA</span>
              </button>

              <button
                mat-stroked-button
                color="primary"
                class="rx-action-btn rx-action-btn--secondary"
                (click)="$event.stopPropagation(); enviarRecetaPorCorreo()">
                <mat-icon>mail</mat-icon>
                <span>ENVIAR POR CORREO</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- LADO DERECHO: TABS -->
      <div class="col-lg-8 col-md-12">
        <mat-accordion multi="true">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>face</mat-icon>
                DATOS DEL PACIENTE
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <section class="datos-block">
                <div class="grid-2">
                  <div class="datos-item"><span class="datos-label">NOMBRE COMPLETO</span><span class="datos-valor">{{ receta.nombresPaciente }} {{ receta.primerApellidoPaciente }} {{ receta.segundoApellidoPaciente }}</span></div>
                  <div class="datos-item"><span class="datos-label">FECHA DE NACIMIENTO</span><span class="datos-valor">{{ receta.fechaNacimientoPaciente }}</span></div>
                  <div class="datos-item"><span class="datos-label">EDAD</span><span class="datos-valor">{{ receta.edad }} AÑOS</span></div>
                  <div class="datos-item"><span class="datos-label">ALTURA</span><span class="datos-valor">{{ receta.pacTalla }} CM</span></div>
                  <div class="datos-item"><span class="datos-label">PESO</span><span class="datos-valor">{{ receta.pacPeso }} KG</span></div>
                  @if (receta.pacCreatinina) {
                    <div class="datos-item"><span class="datos-label">ACLARAMIENTO CREATININA</span><span class="datos-valor">{{ receta.pacCreatinina }} ML/MIN</span></div>
                  }
                </div>
              </section>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="receta.patologias.length > 0 || receta.alergias.length > 0 || receta.molecules.length > 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>assignment</mat-icon>
                DIAGNOSTICO
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <section class="diagnostico-wrapper">
                <div class="clinical-grid">
                  @if (receta.patologias.length > 0) {
                    <div class="clinical-card clinical-card-full">
                      <div class="clinical-card-head">
                        <div class="clinical-card-title">
                          <mat-icon>monitor_heart</mat-icon>
                          <span>PATOLOGIAS</span>
                        </div>
                        <span class="clinical-count">{{ receta.patologias.length }}</span>
                      </div>

                      <div class="clinical-list">
                        @for (row of receta.patologias; track row) {
                          <div class="clinical-entry clinical-entry-inline">
                            <div class="clinical-entry-title">
                              <span>{{ row.nameCIM10 }}</span>
                              @if (row.code) {
                                <span class="clinical-chip">CODIGO {{ row.code }}</span>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (receta.alergias.length > 0) {
                    <div class="clinical-card clinical-card-full">
                      <div class="clinical-card-head">
                        <div class="clinical-card-title">
                          <mat-icon>warning_amber</mat-icon>
                          <span>ALERGIAS</span>
                        </div>
                        <span class="clinical-count">{{ receta.alergias.length }}</span>
                      </div>

                      <div class="clinical-list">
                        @for (row of receta.alergias; track row) {
                          <div class="clinical-entry clinical-entry-inline">
                            <div class="clinical-entry-title">{{ row.nameAllergy }}</div>
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (receta.molecules.length > 0) {
                    <div class="clinical-card clinical-card-full">
                      <div class="clinical-card-head">
                        <div class="clinical-card-title">
                          <mat-icon>biotech</mat-icon>
                          <span>MOLECULAS</span>
                        </div>
                        <span class="clinical-count">{{ receta.molecules.length }}</span>
                      </div>

                      <div class="clinical-list">
                        @for (row of receta.molecules; track row) {
                          <div class="clinical-entry clinical-entry-inline">
                            <div class="clinical-entry-title">{{ row.nameMolecule }}</div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </section>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>list_alt</mat-icon>
                MEDICAMENTOS
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-content">
              @for (detalle of detalles; track detalle) {
                <div class="medicamento-card">
                  <div class="medicamento-header">
                    <mat-icon class="medicamento-icon">medication</mat-icon>
                    <span class="medicamento-nombre">{{ detalle.medicamento }}</span>
                  </div>
                  <div class="medicamento-body">
                    <div class="grid-2">
                      <div class="datos-item"><span class="datos-label">Dosis</span><span class="datos-valor">{{ detalle.cantidadDiaria }} {{ detalle.unidadDispensacion }}</span></div>
                      <div class="datos-item"><span class="datos-label">Frecuencia</span><span class="datos-valor">CADA {{ detalle.frecuency }} {{ detalle.frecuencyType }} POR {{ detalle.duracion }} {{ detalle.unidadDuracion }}</span></div>
                      <div class="datos-item"><span class="datos-label">Via de administracion</span><span class="datos-valor">{{ detalle.rutaAdministracion | capitalize }}</span></div>
                      <div class="datos-item"><span class="datos-label">Tipo</span><span class="datos-valor">{{ detalle.medicamentoType | medicamentoTypeLabel }}</span></div>
                      <div class="datos-item"><span class="datos-label">Inicio</span><span class="datos-valor">{{ detalle.periodoInicio }}</span></div>
                      <div class="datos-item"><span class="datos-label">Termino</span><span class="datos-valor">{{ detalle.periodoTerminacion }}</span></div>
                      <div class="datos-item">
                        <span class="datos-label">Surtido</span>
                        <span class="status-chip" [ngClass]="detalle.surtido ? 'status-success' : 'status-danger'">{{ detalle.surtido ? 'SI' : 'NO' }}</span>
                      </div>
                    </div>
                    <div class="datos-item full-width mt-3">
                      <span class="datos-label">Indicaciones de Uso</span>
                      <span class="datos-valor">{{ detalle.observaciones }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </div>
  </div>
</section>
